import { AuthStorage } from "utils/auth-storage";
import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveReportAccessLevel } from "redux/permission-reducer";
import { ReportServices } from "apis/Services/ReportService";
import { WarehouseServices } from "apis/Services/WarehouseService";
import { Button, Input } from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import LoadingComponent from "components/loading-component";
import TransferModal from "./transfer-modal";
import styles from "./warehouse-dashboard.module.css";
import MaterialsTable from "./materials-table";
import LockRoundedIcon from "@mui/icons-material/LockRounded";
import PostToProcoreModal from "./post-to-procore-modal";
import ImportInventory from "./import-inventory";

export default function WarehouseInventory() {
  const { company_id, id } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [accessLevel, setAccessLevel] = useState();
  const [data, setData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [isTransferVisible, setIsTransferVisible] = useState(false);
  const [isPostToProcoreVisible, setIsPostToProcoreVisible] = useState(false);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [locationsOptions, setLocationsOptions] = useState([]);
  const [unitsOptions, setUnitsOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [shouldReload, setShouldReload] = useState(false);
  const tableRef = useRef();

  const { reportAccessLevel } = useSelector((state) => state.permission);
  const dispatch = useDispatch();

  function getAccessLevel() {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.inventoryPageAccessLevel(ReqObj)
      .then((res) => {
        setAccessLevel(parseInt(res.accessLevel));
        if (parseInt(res?.accessLevel) > 0) {
          getData();
          getUnits();
        } else {
          setisLoading(false);
        }
        dispatch(saveReportAccessLevel(res.accessLevel));
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getData() {
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getWarehouseItems(ReqObj)
      .then((items) => {
        setData(Array.isArray(items) ? items : []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setisLoading(false));
  }

  function getUnits() {
    setisLoading(true);
    let code = AuthStorage.getItem("token");
    let email = AuthStorage.getItem("email");
    let ReqObj = {
      company: company_id,
      project: id,
      code,
      loginEmail: email,
    };
    WarehouseServices.getInventorySettings(ReqObj)
      .then((res) => {
        console.log("Units:", res);
        setCategoryOptions(res.settingsDict.categories);
        setSubcategoryOptions(res.settingsDict.subcategories);
        setLocationsOptions(res.settingsDict.locations);
        setUnitsOptions(res.settingsDict.units);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setisLoading(false));
  }

  const handleTransferModal = (record) => {
    setSelectedItem(record);
    setIsTransferVisible(true);
  };

  const handlePostToProcoreModal = (record) => {
    setSelectedItem(record);
    setIsPostToProcoreVisible(true);
  };

  const handleAddNew = () => {
    if (tableRef.current) {
      tableRef.current.openAddModal();
    }
  };

  const handleExportCsv = () => {
    tableRef.current?.exportToCsv?.();
  };

  useEffect(() => {
    if (shouldReload) {
      getData();
      setShouldReload(false);
    }
  }, [shouldReload]);

  useEffect(() => {
    getAccessLevel();
  }, []);

  return (
    <div className=" bg-white p-4 rounded-3 p-2 d-flex flex-column justify-content-center">
      {isLoading && (
        <div className="row d-flex justify-content-center">
          <LoadingComponent />
        </div>
      )}

      {!isLoading && accessLevel === 0 && (
        <div className="row w-100 d-flex justify-content-center p-5">
          {!isLoading && accessLevel === 0 && (
            <div className="row w-100 d-flex justify-content-center p-5">
              <div className="d-flex flex-column align-items-center text-center gap-3">
                <LockRoundedIcon style={{ fontSize: "5rem", color: "#999" }} />
                <h6 className="mt-2 mb-0 text-muted">
                  You do not have the necessary permissions to access this page.
                </h6>
              </div>
            </div>
          )}
        </div>
      )}

      {!isLoading && accessLevel > 0 && (
        <div style={{ width: "85%" }} className=" align-self-center">
          <div className="row">
            <div>
              <h3 className="fw-bold p-0 m-0">Inventory Management</h3>
              <p className="opacity-75 mt-2 p-0">
                Track and manage all construction materials in your warehouse
              </p>
            </div>
          </div>

          <div className="row mt-2">
            <div className="d-flex flex-wrap gap-2 justify-content-between align-items-center mb-3">
              <Input
                placeholder="Search materials, SKUs, or categories..."
                prefix={<SearchOutlined />}
                style={{ width: "330px" }}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              <div className=" d-flex gap-2">
                <Button
                  size="large"
                  onClick={handleExportCsv}
                  disabled={isLoading || data.length < 1}
                >
                  <DownloadOutlined /> Export to CSV
                </Button>

                {accessLevel > 1 && (
                  <>
                  <ImportInventory
                    categoryOptions={categoryOptions}
                    subcategoryOptions={subcategoryOptions}
                    locationsOptions={locationsOptions}
                    unitsOptions={unitsOptions}
                    setShouldReload={setShouldReload}
                  />
                  <Button type="primary" onClick={handleAddNew} size="large">
                    <PlusOutlined /> Add Material
                  </Button>
                  </>
                )}
              </div>
            </div>

            <MaterialsTable
              ref={tableRef}
              data={data}
              categoryOptions={categoryOptions}
              subcategoryOptions={subcategoryOptions}
              locationsOptions={locationsOptions}
              unitsOptions={unitsOptions}
              onDataUpdate={getData}
              showTransferModal={handleTransferModal}
              showPostToProcoreModal={handlePostToProcoreModal}
              searchText={searchText}
              loading={isLoading}
              showActions={true}
              accessLevel={accessLevel}
            />
          </div>
        </div>
      )}

      <TransferModal
        isTransferVisible={isTransferVisible}
        setIsTransferVisible={setIsTransferVisible}
        record={selectedItem}
        materialsOptions={data}
        setShouldReload={setShouldReload}
      />

      <PostToProcoreModal
        isPostToProcoreVisible={isPostToProcoreVisible}
        setIsPostToProcoreVisible={setIsPostToProcoreVisible}
        record={selectedItem}
        materialsOptions={data}
        setShouldReload={setShouldReload}
      />
    </div>
  );
}
